$.ajaxSetup({
    beforeSend: function (xhr, settings) {
        var metodo = (settings.type || '').toUpperCase();
        if (metodo === 'POST' || metodo === 'PUT' || metodo === 'PATCH' || metodo === 'DELETE') {
            var meta = document.querySelector('meta[name="csrf-token"]');
            if (meta) {
                xhr.setRequestHeader('X-CSRF-Token', meta.getAttribute('content'));
            }
        }
    }
});

window.DataTableLanguage = window.DataTableLanguage || {
    info: "Página _PAGE_ de _PAGES_",
    lengthMenu: "_MENU_ ",
    search: "",
    searchPlaceholder: "Buscar",
    infoEmpty: "Nenhum registro encontrado",
    infoFiltered: "(Filtrado de _MAX_ registros)",
    zeroRecords: "Nenhum registro encontrado",
    paginate: {
        first: "Primeira",
        last: "Último",
        next: "Próximo",
        previous: "Anterior"
    },
}

window.Toast = window.Toast || Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

window.setTablePagination = window.setTablePagination || function() {
    document.querySelectorAll('.dataTables_paginate .pagination').forEach(dt => {
        dt.classList.add('pagination-primary');
    });
};

function validaCNPJ(cnpj) {
    // Remove todos os caracteres que não sejam números
    cnpj = cnpj.replace(/[^\d]+/g, '');

    // Verifica se o CNPJ tem exatamente 14 dígitos
    if (cnpj.length !== 14) return false;

    // Elimina CNPJs inválidos conhecidos
    if (/^(\d)\1{13}$/.test(cnpj)) return false;

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return false;

    return true;
}
function validaCPF(cpf) {
    var Soma = 0
    var Resto

    var strCPF = String(cpf).replace(/[^\d]/g, '')

    if (strCPF.length !== 11)
        return false

    if ([
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
    ].indexOf(strCPF) !== -1)
        return false

    for (i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);

    Resto = (Soma * 10) % 11

    if ((Resto == 10) || (Resto == 11))
        Resto = 0

    if (Resto != parseInt(strCPF.substring(9, 10)))
        return false

    Soma = 0

    for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)

    Resto = (Soma * 10) % 11

    if ((Resto == 10) || (Resto == 11))
        Resto = 0

    if (Resto != parseInt(strCPF.substring(10, 11)))
        return false

    return true
}
function getHojeISO() {
    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, '0');
    const mes = String(hoje.getMonth() + 1).padStart(2, '0'); // Janeiro = 0
    const ano = hoje.getFullYear();
    return `${ano}-${mes}-${dia}`; // formato ISO yyyy-MM-dd
}

function formatarData(data) {
    var partesData = data.split('-');
    var dataFormatada = partesData[2] + '/' + partesData[1] + '/' + partesData[0];
    return dataFormatada;
}

function setHojeData() {
    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, '0');
    const mes = String(hoje.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    const ano = hoje.getFullYear();
    const dataHoje = `${dia}/${mes}/${ano}`;
    return dataHoje;
}

function formatCNPJ(cnpj) {
    if (!cnpj) return '';
    cnpj = String(cnpj).replace(/[^0-9A-Za-z]/g, '').toUpperCase();
    if (cnpj.length !== 14) return cnpj; // devolve cru se não tiver 14
    return cnpj.slice(0, 2) + '.' + cnpj.slice(2, 5) + '.' + cnpj.slice(5, 8) +
           '/' + cnpj.slice(8, 12) + '-' + cnpj.slice(12, 14);
}
// Exporta a função formatCNPJ para o objeto global window
window.formatCNPJ = formatCNPJ;

function formatCEP(cep) {
    if (!cep) return '';
    cep = String(cep);

    if (cep && cep.length === 8) {
        return cep.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2-$3');
    }
    return cep;
}

// Exporta a função formatCEP para o objeto global window
window.formatCEP = formatCEP;

function formatTEL(tel) {
    if (!tel) return '';
    var d = String(tel).replace(/\D/g, '');
    if (d.length === 11) return '(' + d.substr(0,2) + ') ' + d.substr(2,5) + '-' + d.substr(7,4);
    if (d.length === 10) return '(' + d.substr(0,2) + ') ' + d.substr(2,4) + '-' + d.substr(6,4);
    return tel;
}
window.formatTEL = formatTEL;

function escapeHtml(v) {
    if (v === null || v === undefined) return '';
    return String(v)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
window.escapeHtml = escapeHtml;

function formatRGMS(regms) {
    return regms.replace(/^(\d{1})(\d{4})(\d{4})(\d{3})(\d{1})$/, '$1.$2.$3.$4-$5');
}
window.formatRGMS = formatRGMS;

function limpaRGMS(regms) {
    return regms.replace(/[\.-]/g, ''); // Remove pontos (.) e traços (-)
}
function removeBrTags(text) {
    if (text != null) {
        // Substituir todas as ocorrências de <br> (com ou sem espaços) por uma string vazia
        return text.replace(/<br\s*\/?>/gi, '');
    }
}

function replaceBrWithNewline(text) {
    if (text != null) {
        // Substitui todas as ocorrências de <br> (com ou sem espaços) por uma quebra de linha (\n)
        return text.replace(/<br\s*\/?>/gi, '\n');
    }
    return text;
}

// Adiciona uma quebra de linha em campo label.
function convertBrToNewline(text) {
    // Substitui todas as ocorrências de <br /> ou <br> por \n
    return text.replace(/<br\s*\/?>/gi, '\n');
}

function getData(controler, data) {
    data = data || {} // para tornar o data como parametro opcional.
    return $.ajax({
        url: controler,
        dataType: 'json',
        type: "GET",
        data: data
    })
}

function postData(controler, data) {
    data = data || {}
    return $.ajax({
        url: controler,
        dataType: 'json',
        type: "POST",
        data: data
    })
}

function handleDocumentUpload(files, previewId) {
    var previewDocuments = document.getElementById(previewId);

    for (var i = 0; i < files.length; i++) {
        var file = files[i];

        if (file && file.type === 'application/pdf') {
            var documentContainer = document.createElement('div');
            documentContainer.classList.add('document-container');

            var documentLink = document.createElement('a');
            documentLink.href = URL.createObjectURL(file);
            documentLink.textContent = file.name;
            documentLink.target = '_blank'; // Abrir o link em uma nova aba

            var closeButton = document.createElement('button');
            closeButton.classList.add('btn');
            closeButton.innerHTML = '<i class="fa fa-trash text-danger"></i>'; // Adiciona o ícone de lixeira

            // Adicionar evento de clique para remover o documento
            closeButton.addEventListener('click', function (event) {
                var documentContainer = event.target.closest('.document-container');
                documentContainer.remove(); // Remove o contêiner do documento do preview
            });

            documentContainer.appendChild(closeButton);
            documentContainer.appendChild(documentLink);
            previewDocuments.appendChild(documentContainer);
        } else {
            Toast.fire({
                icon: "warning",
                text: "Por favor, selecione apenas arquivos PDF.",
            });
            document.getElementById('inputDocumentos').value = ''; // Limpa o input de arquivo para permitir uma nova seleção
            return; // Aborta o loop se um arquivo inválido for encontrado
        }
    }
}

function visualizarArquivoPDF(pdfLink, imageId, callback, previewId) {
    var previewDocuments = document.getElementById(previewId);

    if (!previewDocuments) {
        console.error("Elemento com o ID " + previewId + " não foi encontrado.");
        return;
    }

    var documentContainer = document.createElement('div');
    documentContainer.classList.add('document-container');

    var documentLink = document.createElement('a');
    var pdfName = extractFileName(pdfLink); // Extrai o nome do arquivo do caminho
    documentLink.href = pdfLink;
    documentLink.textContent = pdfName; // Exibe o nome original do arquivo
    documentLink.target = '_blank'; // Abrir o link em uma nova aba

    var closeButton = document.createElement('button');
    closeButton.classList.add('btn');
    closeButton.innerHTML = '<i class="fa fa-trash text-danger"></i>'; // Adiciona o ícone de lixeira

    // Adiciona o ID do anexo ao array quando o botão de fechar é clicado
    closeButton.addEventListener('click', function () {
        var pdfId = imageId; // Use o ID do anexo fornecido
        //console.log('ID do documento:', pdfId);
        idAnexosExcluir = pdfId;
        //console.log('ID do idexcluirDoc:', idAnexosExcluir);
        callback(pdfId); // Chama o callback passando o ID do anexo excluído
        documentContainer.remove(); // Remove o contêiner do PDF do preview
    });

    documentContainer.appendChild(documentLink);
    documentContainer.appendChild(closeButton);
    previewDocuments.appendChild(documentContainer);

    return imageId;
}

// Função para extrair o nome do arquivo do caminho e remover o _uniqid() se presente
function extractFileName(filePath) {
    var fileName = filePath.split('/').pop(); // Obtém a parte do caminho após a última barra
    var extensionIndex = fileName.lastIndexOf('.'); // Encontra o índice da última ocorrência do ponto (.)
    if (extensionIndex !== -1) {
        var fileNameWithoutExtension = fileName.slice(0, extensionIndex); // Remove a extensão do nome do arquivo
        var fileNameWithoutUniqid = fileNameWithoutExtension.slice(0, -14); // Remove os últimos 14 caracteres, que incluem o _uniqid()
        return fileNameWithoutUniqid + fileName.slice(extensionIndex); // Recria o nome do arquivo com a extensão, sem o _uniqid()
    } else {
        return fileName; // Retorna o nome do arquivo original se não houver extensão
    }
}

var anexosParaExcluir = [];
// Função para obter os IDs dos anexos para exclusão ao salvar
function getAnexosParaExcluir() {
    anexosParaExcluir.push(idAnexosExcluir); // Use idAnexosExcluir em vez de idAnexosExcluirDoc
    //console.log('Conteúdo do array anexosParaExcluir:', anexosParaExcluir);
    return anexosParaExcluir;
}

var idAnexosExcluir = 0; // Defina a variável fora da função

// Função visualizarImagem modificada para aceitar um callback
function visualizarImagem(imageLink, anexoId, callback, previewId) {
    imagensCompactadas = [];
    var previewImages = document.getElementById(previewId);
    var imgContainer = document.createElement('div');
    imgContainer.classList.add('img-container');

    var img = new Image();
    img.src = imageLink;
    img.style.maxWidth = '250px';

    var link = document.createElement('a');
    link.href = img.src;
    link.target = '_blank';
    link.appendChild(img);

    var closeButton = document.createElement('button');
    closeButton.classList.add('close-button');
    closeButton.innerHTML = 'x';

    // Adiciona o ID do anexo ao array quando o botão de fechar é clicado
    closeButton.addEventListener('click', function () {
        var imgId = anexoId; // Use o ID do anexo fornecido
        //console.log('ID do anexo:', imgId);
        idAnexosExcluir = imgId;
        //console.log('ID do idexcluir:', idAnexosExcluir);
        callback(imgId); // Chama o callback passando o ID do anexo excluído
        var imgContainer = closeButton.closest('.img-container');
        imgContainer.remove();
    });

    imgContainer.appendChild(link);
    imgContainer.appendChild(closeButton);
    previewImages.appendChild(imgContainer);

    // Retorna o ID do anexo adicionado
    return anexoId;
}

window.imagensCompactadas = window.imagensCompactadas || [];
// Função para verificar e compactar o arquivo, se necessário
function verificarECompactar(files, imagemElemento) {
    var previewImages = document.getElementById(imagemElemento);

    for (var i = 0; i < files.length; i++) {
        var file = files[i];

        if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
            var imgContainer = document.createElement('div'); // Cria um contêiner para a imagem e o botão de remoção
            imgContainer.classList.add('img-container'); // Adiciona uma classe ao contêiner para estilização CSS

            var tamanhoOriginal = file.size;
            //console.log('Tamanho Original:', tamanhoOriginal); // Log do tamanho original

            if (tamanhoOriginal > 548576) { // Verifica se é maior que 500KB (em bytes)
                var compressor = new Compressor(file, {
                    quality: 1,
                    maxWidth: 500,
                    maxHeight: 500,
                    success(result) {
                        imagensCompactadas.push(result);
                    },
                    error(err) {
                        console.error('Erro ao compactar a imagem:', err.message);
                    },
                });
            } else {
                imagensCompactadas.push(file);
            }
            var img = new Image();
            img.src = URL.createObjectURL(file);
            img.style.maxWidth = '250px'; // Defina o tamanho máximo da imagem conforme desejado

            var closeButton = document.createElement('button');
            closeButton.classList.add('close-button'); // Adiciona uma classe ao botão de fechar para estilização CSS
            closeButton.innerHTML = 'x'; // Adiciona o ícone 'x' ao botão de fechar

            // Adiciona um evento de clique ao botão de fechar para remover a imagem do preview
            closeButton.addEventListener('click', function () {
                var imgContainer = event.target.closest('.img-container');
                var imgElement = imgContainer.querySelector('img');

                // Encontrar a imagem compactada associada à imagem no contêiner
                var imgSrc = imgElement.src;
                var compactedImg = imagensCompactadas.find(img => img.src === imgSrc);

                // Remover a imagem compactada do array imagensCompactadas
                if (compactedImg) {
                    var index = imagensCompactadas.indexOf(compactedImg);
                    if (index !== -1) {
                        imagensCompactadas.splice(index, 1); // Remove a imagem compactada do array
                    }
                }

                imgContainer.remove(); // Remove o contêiner da imagem do preview
            });


            imgContainer.appendChild(img); // Adiciona a imagem ao contêiner
            imgContainer.appendChild(closeButton); // Adiciona o botão de fechar ao contêiner
            previewImages.appendChild(imgContainer); // Adiciona o contêiner ao previewImages
        } else {
            alert("Por favor, selecione apenas arquivos de imagem JPG ou PNG.");
            document.getElementById('inputImagem').value = ''; // Limpa o input de arquivo para permitir uma nova seleção
            return; // Aborta o loop se um arquivo inválido for encontrado
        }
    }
}

/*
 * Compacta um único arquivo de imagem (uso: avatar/foto de perfil).
 * Diferente de verificarECompactar(): arquivo único, sem preview/DOM próprio,
 * devolve o resultado via callback pro chamador decidir o que fazer com ele.
 *
 * JPEG abaixo de 1MB devolve o próprio file sem processar — evita o custo de
 * decode/reencode do Compressor.js em arquivo que já é pequeno. PNG sempre passa
 * pelo Compressor, mesmo pequeno: o destino final é sempre .jpg (o servidor grava
 * e lê como .jpg e valida o conteúdo com getimagesize()), então PNG precisa da
 * conversão de mimeType independente de tamanho — senão o servidor rejeita por o
 * conteúdo não ser JPEG real.
 */
function compactarFotoPerfil(file, onSuccess, onError) {
    if (!file || (file.type !== 'image/jpeg' && file.type !== 'image/png')) {
        if (typeof onError === 'function') onError(new Error('Tipo de arquivo não suportado.'));
        return;
    }

    if (file.type === 'image/jpeg' && file.size <= 1048576) { // 1MB
        onSuccess(file);
        return;
    }

    new Compressor(file, {
        quality: 0.85,
        maxWidth: 600,
        maxHeight: 600,
        mimeType: 'image/jpeg',
        success: onSuccess,
        error: function (err) {
            if (typeof onError === 'function') onError(err);
        }
    });
}

function aplicarMascaraMonetaria(selector) {
    Inputmask({
        alias: 'numeric',
        groupSeparator: '.',
        radixPoint: ',',
        autoGroup: true,
        digits: 2,
        digitsOptional: false,
        placeholder: '0',
        rightAlign: false,
        removeMaskOnSubmit: true,
        onUnMask: function (maskedValue, unmaskedValue) {
            // Converter o valor desmascarado com vírgula para ponto decimal
            let finalValue = maskedValue.replace(/\./g, '').replace(',', '.');
            return finalValue;
        }
    }).mask(selector);
}

function formatarDataHoje() {
    var hoje = new Date();
    var dia = String(hoje.getDate()).padStart(2, '0');
    var mes = String(hoje.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
    var ano = hoje.getFullYear();
    return ano + '-' + mes + '-' + dia;
}

function formatarParaCampoMonetario(valor) {
    // Converte o valor para um número flutuante
    let floatValue = parseFloat(valor);

    // Formata o número com duas casas decimais e substitui o ponto por vírgula
    let formattedValue = floatValue.toFixed(2).replace('.', ',');

    return formattedValue;
}

function restauraItens(itensSelecionados) {
    var selectedItemsJSON = sessionStorage.getItem(itensSelecionados);
    console.log('itens Selecionados:' + selectedItemsJSON);
    return JSON.parse(selectedItemsJSON);
}
async function select2Gen(
    campoId, // Identificador do campo ID
    selectElemento, // Elemento <select> que será inicializado
    dataControllerUrl = null, // URL para buscar os dados (opcional)
    campoDescricao, // Campo usado como descrição nos options
    placeholderText, // Placeholder para o Select2
    idSelecionado = 0, // Valor pré-selecionado (opcional)
    nomeModal = null, // Nome do modal (opcional)
    ajaxData = null, // Dados adicionais para a chamada AJAX (opcional)
    data = null // Dados opcionais (pode ser passado diretamente)
) {
    // Limpar todas as opções existentes
    $(`#${selectElemento}`).empty();

    // Obter dados: priorizar 'data' se fornecido, caso contrário, buscar via URL
    let dataItems = [];
    if (data) {
        dataItems = data; // Usar os dados fornecidos diretamente
    } else if (dataControllerUrl) {
        dataItems = await getData(dataControllerUrl, ajaxData).then(function (data) {
            return data;
        });
    }

    // Configuração do Select2
    let selectConfig = {
        placeholder: placeholderText,
        allowClear: true // Permite limpar a seleção
    };

    // Definir o dropdownParent se fornecido
    if (nomeModal) {
        selectConfig.dropdownParent = $(`#${nomeModal}`);
    }

    // Inicializar o Select2
    $(`#${selectElemento}`).select2(selectConfig);

    // Adicionar opções ao Select
    dataItems.forEach(item => {
        let isSelected = idSelecionado == item[campoId]; // Verifica se o item deve ser selecionado

        let description = typeof campoDescricao === 'function'
            ? campoDescricao(item) // Se campoDescricao for uma função, chama-a
            : item[campoDescricao]; // Caso contrário, usa o campo diretamente

        let newOption = new Option(description, item[campoId], isSelected, isSelected);
        $(`#${selectElemento}`).append(newOption);
    });

    // Configurar o valor inicial do Select
    if (idSelecionado == 0) {
        $(`#${selectElemento}`).val(null).trigger('change');
    } else {
        $(`#${selectElemento}`).val(idSelecionado).trigger('change');
    }
}

//Função para realizar um upsert no banco de dados
function upsertData(data, Nomeobjeto, nomeCtrl, fncGetDados) {
    return $.ajax({
        url: nomeCtrl,
        type: "POST",
        dataType: "json",
        processData: false,
        contentType: false,
        data: data,
    }).then(function (data) {
        Toast.fire({
            icon: data.type,
            text: data.message,
        });
        $(`#upsert-modal-${Nomeobjeto}`).modal('hide');

        // Verificar se fncGetDados foi passada antes de chamá-la
        if (typeof fncGetDados === "function") {
            fncGetDados();
        }

        return data.id;  // Retorna o ID aqui
    }).catch(function (error) {
        console.log(error);
    });
}

//Função para deletar um registro da base de dados
function deleteData(
    data,
    Nomeobjeto,
    nomeCtrl,
    fncGetDados) {
    $.ajax({
        url: nomeCtrl,
        type: "DELETE",
        dataType: "json",
        data: data,
        success: function (data) {
            Toast.fire({
                icon: data.type,
                text: data.message,
            });
            $(`#delete-modal-${Nomeobjeto}`).modal('hide');
            fncGetDados();
        },
        error: function (error) {
            if (error.responseJSON !== undefined) {
                Toast.fire({
                    icon: error.responseJSON.type,
                    text: error.responseJSON.message,
                });
            }
            $(`#delete-modal-${Nomeobjeto}`).modal('hide');
        }
    });
}

// função para preencher os campos de um modal de edição
function preencherCampos(data) {
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            const selector = `#${key}`;
            if ($(selector).length) {
                // Define o valor do elemento
                $(selector).val(data[key]).trigger('change');
            }
        }
    }
}

// Cancelamento de entrada/saída com a regra do ECPharma. Quem decide é o servidor; a tela
// só abre a janela pelo codigo da resposta (o texto vem do servidor, sempre como texto):
// - houve_saida: janela de erro só com OK, nada é cancelado;
// - confirmar_periodo_enviado: janela de atenção com "Não" como botão principal; só no
//   "Sim" repete o DELETE com confirmar_sngpc=SIM.
// aoTerminar() roda a cada resposta (fechar o modal da tela e recarregar a lista).
// sim = true manda confirmar_sngpc=SIM já no primeiro DELETE (o "Sim" do aviso).
// As janelas aqui só aparecem se a situação mudou depois da consulta de pedirCancelamentoSngpc.
function cancelarMovimentoSngpc(url, dados, aoTerminar, sim) {
    if (sim) dados = $.extend({}, dados, { confirmar_sngpc: 'SIM' });
    $.ajax({ url: url, type: 'DELETE', dataType: 'json', data: dados })
        .done(function (r) {
            aoTerminar();
            if (r && r.codigo === 'houve_saida') {
                Swal.fire({ icon: 'error', text: r.message, confirmButtonText: 'OK' });
                return;
            }
            if (r && r.codigo === 'confirmar_periodo_enviado' && dados.confirmar_sngpc !== 'SIM') {
                Swal.fire({
                    icon: 'warning',
                    text: r.message,
                    confirmButtonText: 'Não',
                    showDenyButton: true,
                    denyButtonText: 'Sim',
                    reverseButtons: true,
                    focusConfirm: true,
                    allowOutsideClick: false
                }).then(function (res) {
                    if (res.isDenied) {
                        cancelarMovimentoSngpc(url, $.extend({}, dados, { confirmar_sngpc: 'SIM' }), aoTerminar);
                    }
                });
                return;
            }
            Toast.fire({ icon: r.status, text: r.message });
        })
        .fail(function (error) { mostraErro(error); });
}

// Clique em cancelar, igual ao ECPharma: UMA janela só, escolhida pela situação que o servidor
// devolve (GET, sem gravar). tipo: 'entrada' ou 'saida'.
// - bloqueio: só a mensagem, com OK;
// - dentro de período enviado: só o aviso de atenção, "Não" principal; no "Sim", cancelarComSim();
// - fora: abrirModal(), o modal "Cancelar item?" de sempre.
function pedirCancelamentoSngpc(tipo, id, abrirModal, cancelarComSim) {
    $.ajax({
        url: 'utilidade-ctrl',
        type: 'GET',
        dataType: 'json',
        data: { acao: 'situacao_cancelamento', tipo: tipo, id: id }
    }).done(function (sit) {
        if (sit.bloqueio) {
            Swal.fire({ icon: 'error', text: sit.bloqueio, confirmButtonText: 'OK' });
            return;
        }
        if (!sit.periodo_enviado) {
            abrirModal();
            return;
        }
        Swal.fire({
            icon: 'warning',
            text: sit.aviso,
            confirmButtonText: 'Não',
            showDenyButton: true,
            denyButtonText: 'Sim',
            reverseButtons: true,
            focusConfirm: true,
            allowOutsideClick: false
        }).then(function (res) {
            if (res.isDenied) cancelarComSim();
        });
    }).fail(function (error) { mostraErro(error); });
}

// Função para tratar erro do ajax
function mostraErro(error) {

    if (window.ErlsoftSession && window.ErlsoftSession.handleIfExpired(error)) return;

    if (error.responseJSON !== undefined) {
        Toast.fire({
            icon: error.responseJSON.type,
            text: error.responseJSON.message,
        });
    } else if (error.responseText) {
        Toast.fire({
            icon: 'error',
            text: error.responseText,
        });

    }
    else {
        console.log(error);
    }

}

//Usado em queixas
function intensidadeCor(intensidade, parte_corpo) {
    let intensidade_cor = '#D1EACA';  // Cor padrão para intensidade nula ou nenhuma
    let intensidade_texto = 'Nenhuma';  // Texto padrão para intensidade nula ou nenhuma
    let color_font = '#FFFFFF';  // Cor padrão da fonte é branca
    let checkboxDisabled = 'disabled';  // Desabilita o checkbox por padrão

    // Verifica se parte_corpo e intensidade são válidos
    if (parte_corpo !== null && intensidade !== null) {
        checkboxDisabled = '';  // Habilita o checkbox

        switch (intensidade) {
            case 0:
            case 1:
                intensidade_cor = 'green';
                intensidade_texto = 'Leve';
                break;
            case 2:
                intensidade_cor = 'yellow';
                intensidade_texto = 'Moderada';
                color_font = 'black';  // Fonte preta para fundo amarelo
                break;
            case 3:
                intensidade_cor = 'red';
                intensidade_texto = 'Forte';
                break;
            case 4:
                intensidade_cor = 'purple';
                intensidade_texto = 'Excessiva';
                break;
            default:
                intensidade_cor = '#D1EACA';  // Cor padrão para casos não previstos
                intensidade_texto = 'Nenhuma';
                color_font = 'black';  // Fonte preta para fundo padrão
                break;
        }
    } else {
        parte_corpo = 'Nenhum';
        color_font = 'black';  // Fonte preta para parte do corpo nula
    }

    return {
        parte_corpo,
        intensidade_cor,
        intensidade_texto,
        color_font,
        checkboxDisabled
    };
}

// Função que converte uma cor hex em um objeto com valores R, G e B
function hexToRgb(hex) {
    let bigint = parseInt(hex.slice(1), 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
    return {
        r,
        g,
        b
    };
}

// Função que converte valores RGB de volta para o formato hex
function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}

// Função para interpolar uma cor
function interpolateColor(color1, color2, factor) {
    if (factor === undefined) factor = 0.5;
    const result = {
        r: Math.round(color1.r + factor * (color2.r - color1.r)),
        g: Math.round(color1.g + factor * (color2.g - color1.g)),
        b: Math.round(color1.b + factor * (color2.b - color1.b)),
    };
    return result;
}

// Função para gerar um range de cores
function generateColorRange(startHex, endHex, steps) {

    const startColor = hexToRgb(startHex);
    const endColor = hexToRgb(endHex);
    const colorRange = [];

    for (let i = 0; i <= steps; i++) {
        const factor = i / steps;
        const interpolatedColor = interpolateColor(startColor, endColor, factor);
        colorRange.push(rgbToHex(interpolatedColor.r, interpolatedColor.g, interpolatedColor.b));
    }

    return colorRange;
}

function getFormattedDate(date) {
    let day = ("0" + date.getDate()).slice(-2);
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let year = date.getFullYear();
    return `${year}-${month}-${day}`;
}

function upsertObjectInArray(array, newObject, key) {
    const index = array.findIndex(item => item[key] === newObject[key]);

    if (index !== -1) {
        array[index] = { ...array[index], ...newObject };
    } else {
        array.push(newObject);
    }
    return array;
}

function cleanApresentation(apres) {
    if (!apres) return '';

    // normaliza: tira &nbsp;, colapsa espaços, uppercase, trim
    var s = String(apres)
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .toUpperCase()
        .trim();

    // 1) CONCENTRAÇÃO: dose completa do início (aceita parêntese e "+")
    var unidade = '(?:MG\\/\\s*ML|MG\\/\\s*G|MCG|MG|G|UI|%)';
    var num = '[0-9]+(?:[.,][0-9]+)?';
    var reConc = new RegExp(
        '^\\(?\\s*' + num + '\\s*' + unidade + '?' +
        '(?:\\s*\\+\\s*' + num + '\\s*' + unidade + '?)*\\s*\\)?'
    );
    var mConc = s.match(reConc);
    var conc = mConc ? mConc[0].replace(/\s+/g, ' ').trim() : '';

    // 2) FORMA: primeira reconhecida (específicas antes das genéricas)
    var padded = ' ' + s + ' ';
    var forma = '';
    var mapa = [
        [/ (SOL\s+INJ|SOL\s+DIL\s+INFUS) /, 'Sol. Injetável'],
        [/ (SUS\s+INJ|PO\s+LIOF\s+(?:SUS\s+)?INJ) /, 'Susp. Injetável'],
        [/ (COM\s+REV|COMP\s+REV) /, 'Comp. Revestido'],
        [/ (CREM\s+DERM|CREM) /, 'Creme'],
        [/ (POM) /, 'Pomada'],
        [/ (GEL) /, 'Gel'],
        [/ (XPE) /, 'Xarope'],
        [/ (GRAN) /, 'Granulado'],
        [/ (SOL\s+OR|SOL) /, 'Solução'],
        [/ (SUSP?|SUS) /, 'Suspensão'],
        [/ (PO\s+LIOF|LIOF) /, 'Pó p/ Solução'],
        [/ (DRG|DRÁGEA|DRAGEA) /, 'Drágea'],
        [/ (TRANSD|ADES) /, 'Transdérmico'],
        [/ (GTS|GOT) /, 'Gotas'],
        [/ (CAPS|CAP|CÁPSULA|CAPSULA) /, 'Cápsula'],
        [/ (COMP|COM) /, 'Comprimido'],
        [/ (PÓ|PO) /, 'Pó']
    ];
    for (var i = 0; i < mapa.length; i++) {
        if (mapa[i][0].test(padded)) { forma = mapa[i][1]; break; }
    }

    // monta resultado. Só um número, sem unidade nem forma ("50" de "50ML/ML 30ML"),
    // não é apresentação: fica o texto limpo.
    var resultado;
    if (!forma && !/[A-Z%]/.test(conc)) {
        resultado = s;
    } else if (conc || forma) {
        resultado = (conc + ' ' + forma).replace(/\s+/g, ' ').trim();
    } else {
        // fallback: original limpo (espaços/&nbsp;), sem extrair
        resultado = s;
    }

    // cabe em 40 (limite do campo)
    return resultado.substring(0, 40);
}

function verificarRegistroMS() {
    esconderAvisoBase();
    let registroMS = document.getElementById('registro_ms').value;
    registroMS = limpaRGMS(registroMS);
    console.log('Registro MS: ', registroMS);
    if (!/^1/.test(registroMS)) {
        Toast.fire({
            icon: 'error',
            text: 'O Registro MS deve começar com o número 1.'
        });
        return;
    }

    if (registroMS.length !== 13) {
        Toast.fire({
            icon: 'error',
            text: 'O Registro MS deve ter exatamente 13 números.'
        });
        return;
    }
    medicamento_id = $("#medicamento_id").val();
    // Primeira verificação: se já existe na tabela medicamentos
    getData('utilidade-ctrl', { acao: 'verificar_registro_ms_existente', registro_ms: registroMS, medicamento_id: medicamento_id })
        .then(data => {
            if (data.existe) {
                Swal.fire({
                    icon: 'error',
                    title: 'Registro MS Já Cadastrado',
                    text: `O medicamento com o Registro MS ${registroMS} já está cadastrado no sistema.`,
                    showConfirmButton: true
                });
                return;
            }

            // Segunda verificação: buscar na base da Anvisa
            getData('utilidade-ctrl', { acao: 'anvisa', registro_ms: registroMS })
                .then(response => {
                    if (response && response.length > 0) {
                        const medicamento = response[0];
                        // Texto da base ERLSoft (cadastro livre do Delphi) não passa pela extração
                        // do formato da ANVISA: só espaço e o limite de 40.
                        const cleanedApresentation = medicamento.texto_da_base
                            ? String(medicamento.apresentacao || '').replace(/\s+/g, ' ').trim().substring(0, 40)
                            : cleanApresentation(medicamento.apresentacao);
                        document.getElementById('nome_medicamento').value = medicamento.produto || '';
                        document.getElementById('apresentacao_medicamento').value = cleanedApresentation || '';
                        preencherCamposAnvisa(medicamento, registroMS);
                        aplicarSugestaoBase(medicamento);

                        Toast.fire({
                            icon: 'success',
                            text: 'O Registro MS Encontrado!'
                        });
                    } else {
                        // Exibir popup de instruções para buscar na Anvisa
                        Swal.fire({
                            icon: 'warning',
                            title: 'Medicamento Não Encontrado',
                            html: `
                                <p>O medicamento com o Registro MS <strong>${escapeHtml(registroMS)}</strong> não foi encontrado em nossa base de dados.</p>
                                <p>Verifique se o número foi digitado corretamente ou consulte diretamente no site da Anvisa seguindo os passos abaixo:</p>
                                <p class="text-danger">O cadastro manual com Registro MS errado pode invalidar o XML do SNGPC.</p>
                                <div style="text-align: left; margin-top: 10px;">
                                    <ol>
                                        <li>Clique no botão para copiar o Registro MS:</li>
                                        <button id="copyButton" type="button" class="btn btn-sm btn-primary my-2">
                                            <i class="fa-solid fa-copy"></i> Copiar Registro
                                        </button>
                                        <li>Acesse a página de consulta da Anvisa;</li>
                                        <li>Cole o número no campo de busca e clique em "Consultar".</li>
                                    </ol>
                                </div>
                                <a href="https://sngpc.anvisa.gov.br/ConsultaMedicamento/index.asp" target="_blank" class="btn btn-primary mt-3">
                                    Consultar na Anvisa
                                </a>
                            `,
                            showConfirmButton: false,
                            showCloseButton: true,
                            // Registro vai por closure, não por onclick: dentro de string JS o escape HTML não protege.
                            didOpen: (popup) => {
                                popup.querySelector('#copyButton').addEventListener('click', () => copyToClipboard(registroMS));
                            },
                        });
                    }
                })
                .catch(error => {
                    console.error('Erro ao buscar dados:', error);
                    Toast.fire({
                        icon: 'error',
                        text: 'Ocorreu um erro ao verificar o Registro MS.'
                    });
                });
        });
}
// DCB, fabricante e unidade vindos do acao=anvisa. DCB sem match fica em branco;
// fabricante sem match é criado no servidor (nome da ANVISA) e já selecionado, sem aviso.
function preencherCamposAnvisa(medicamento, registroMS) {
    $('#unidade_medida').val(medicamento.unidade_medida || null).trigger('change');
    $('#select_dcb').val(medicamento.numero_dcb || null).trigger('change');

    if (medicamento.fabricante_id) {
        selecionarFabricante(medicamento.fabricante_id, null);
        return;
    }
    $('#select_fabricante').val(null).trigger('change');
    postData('utilidade-ctrl', { acao: 'fabricante_anvisa', registro_ms: registroMS })
        .then(function (resp) {
            if (resp && resp.fabricante_id) {
                selecionarFabricante(resp.fabricante_id, resp.nome_fabricante);
            }
        })
        .catch(function (error) {
            console.error('Erro ao definir o fabricante:', error);
        });
}

// Sugestão da base ERLSoft (helpers/medicamentos_base.php). "completo": tipo de receita e
// lista também (a classe segue o tipo e o salvar continua pedindo a confirmação dela);
// "revisar": nem tipo nem lista, com o aviso de classe a revisar. O aviso aparece sempre
// que a lupa preenche o card. MS ainda não confirmado (motivo 'ms': fora da ANVISA/CMED e
// sem XML validado) tem aviso próprio.
function aplicarSugestaoBase(medicamento) {
    var base = medicamento.base || null;
    if (base && base.situacao === 'completo') {
        $('#tipo_receita').val(base.tipo_receita).trigger('change');
        if (base.lista && base.lista !== 'SC') {
            $('#lista_substancia').val(base.lista).trigger('change');
        }
    }
    var revisar = !!(base && base.situacao === 'revisar');
    var $aviso = $('#aviso_base_erlsoft');
    $aviso.find('.aviso-base-texto').text('Dados sugeridos pela base ERLSoft. Confira: a responsabilidade pelo cadastro é do farmacêutico.');
    $aviso.find('.aviso-base-revisar').text(revisar ? 'Classe a revisar pelo farmacêutico.' : '').toggleClass('d-none', !revisar);
    var msPendente = revisar && base.motivo === 'ms';
    $aviso.find('.aviso-base-ms')
        .text(msPendente ? 'Registro MS ainda não confirmado pela ANVISA. Confira antes de salvar: cadastro errado pode invalidar o XML.' : '')
        .toggleClass('d-none', !msPendente);
    $aviso.removeClass('d-none');
}

function esconderAvisoBase() {
    $('#aviso_base_erlsoft').addClass('d-none');
}

// Fabricante recém-criado ainda não está nas options carregadas na abertura do modal.
function selecionarFabricante(id, nome) {
    var $sel = $('#select_fabricante');
    if (nome && !$sel.find('option').filter(function () { return this.value == id; }).length) {
        $sel.append(new Option(nome, id, false, false));
    }
    $sel.val(String(id)).trigger('change');
}

function duasPrimeirasPalavras(frase) {
    if (!frase) return '';
    var s = String(frase).trim();

    // Captura: primeira palavra, separador (espaços ou hífen), segunda palavra
    var m = s.match(/^([^\s-]+)([-\s]+)?([^\s-]+)?/);
    if (!m) return '';

    // Se tem 2ª palavra, mantém hífen se ele era o separador; senão usa espaço
    if (m[3]) {
        var sep = (m[2] && m[2].indexOf('-') !== -1) ? '-' : ' ';
        return m[1] + sep + m[3];
    }
    // Só 1 palavra
    return m[1];
}

function copyToClipboard(text) {
    navigator.clipboard.writeText(text)
        .catch((error) => {
            console.error('Erro ao copiar o texto:', error);
        });
}

function decodeHtmlEntities(str) {
    if (!str) return '';
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
}